import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { EditServicesStateProps, EditServicesType } from './EditServices.types'
import { IApplication } from '../../../../../reducers/Reducers.interfaces'
import {
    Button,
    ButtonType,
    Card, CardContainer,
    CardContent,
    CardSizeTypes,
    Checkbox,
    CheckboxChangeEvent,
    Form,
    SubmitButton
} from '@digicert/dcone-common-ui'
import { Translate } from 'react-localize-redux'
import styles from './EditServices.module.scss'
import createAccountStyles from '../../../../create-account/CreateAccount.module.scss'
import { serviceIcon, translate } from '../../../../../shared/helpers/utils'
import cn from 'classnames'
import { CERT_CENTRAL_SHORT_APP_CODE } from '../../../../../core/constants'
import { editTenant } from 'secure-pages/tenants/Tenants.actions'
import { IAppState } from 'core/store/store'
import moment from 'moment'
import {ThunkDispatch} from 'redux-thunk'
import {AnyAction} from 'redux'

export const EditServices = (
  {
      onCancel,
      refresh,
      services,
      account
  }: EditServicesType) => {
    const dispatch: ThunkDispatch<IAppState, any, AnyAction> = useDispatch()
    const [selectedServices, setSelectedServices] = useState<IApplication[]>(services)
    const [showRecommendations, setShowRecommendations] = useState(false)
    const [createDconeAccount, setCreateDconeAccount] = useState<boolean>(true)
    const [dconeAccountDirty, setDconeAccountDirty] = useState(false)
    const profile = useSelector((state: IAppState) => state.profile.data)

    useEffect(() => {
        setSelectedServices(services)
        setShowRecommendations(false)
        setCreateDconeAccount(true)
        setDconeAccountDirty(false)
    }, [onCancel])

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        const postData = {
            name: account.name,
            locale: account.locale,
            instant_account_provisioning: createDconeAccount,
            'service_period': {
                from: account.service_period.from,
                to: moment(account.service_period.to)
            },
            applications: selectedServices.map(service => {
                return service.id
            })
        }
        dispatch(editTenant(account.id, postData, profile?.access_scope, "notifications.accounts.servicesUpdated"))
        if (onCancel) {
            onCancel()
        }
        setTimeout(() => {
            refresh()
        }, 500)

    }

    const handleCancel = (e) => {
        e.preventDefault()
        if(onCancel) {
            onCancel()
        }
    }

    const selectService = (e: MouseEvent, item: IApplication): void => {
        e.preventDefault()
        let tmpArray:Array<IApplication> = [...selectedServices]
        const serviceExists = selectedServices.some(service => service.id === item.id)

        if(!serviceExists) {
            tmpArray.push(item)
            setSelectedServices(tmpArray)
        }

        else {
            let filterService = tmpArray.filter(service => service.id !== item.id)
            setSelectedServices(filterService)
        }
    }

    const getApplications = () => {
        const applications: Array<any> = []
        const apps = profile?.applications
        if (apps) {
            Object.keys(apps).reduce(
              (val, key) => {
                  const application = {
                      name: apps[key].name,
                      id: apps[key].id,
                  }
                  applications.push(application)
                  return application
              },
              {}
            )
        }

        applications?.sort((a, b) => (a.label > b.label ? 1 : -1))
        return applications
    }

    useEffect(() => {
        const serviceIsCertCentral = selectedServices.some(service => service.short_app_code === CERT_CENTRAL_SHORT_APP_CODE)

        if(selectedServices.length !== 0) {
            // if selection is only CC deselect createDconeAccount and hide recommendations
            if(selectedServices.length === 1 && serviceIsCertCentral) {
                setCreateDconeAccount(false)
                setShowRecommendations(false)
            }
            else {
                setShowRecommendations(true)
                if(!dconeAccountDirty) {
                    setCreateDconeAccount(true)
                }
            }
        }

        else {
            setShowRecommendations(false)
            setCreateDconeAccount(false)
        }
    }, [selectedServices, dconeAccountDirty]);

    return (
      <div className={styles.editServices}>
          <h3><Translate id='accounts.availableServices'/></h3>
          <p><Translate id='accounts.serviceSelectionDescription'/></p>

          <Form center={false} onSubmit={(e) => onSubmit(e)}>
              <CardContainer className={styles.cardContainer}>
                  {getApplications().map((item, index) => {
                      return (
                        <Card
                          key={index}
                          className={styles.card}
                          size={CardSizeTypes.SMALL}
                          onClick={(e: MouseEvent) => selectService(e, item)}
                          content={
                              <CardContent>
                                  <div className={styles.cardContent} key={index}>
                                      <div>{serviceIcon(item.name)}</div>
                                      <div className={styles.cardLabel}>{item.name}</div>
                                      <div>
                                          <Checkbox
                                            checked={selectedServices.some(service => service.id === item.id)}/>
                                      </div>
                                  </div>
                              </CardContent>}
                        />
                      )
                  })}
              </CardContainer>

              <div
                className={cn(styles.recommendations, !showRecommendations && styles.hide)}>
                  <Checkbox
                    className={styles.checkGroup}
                    onChange={(e: CheckboxChangeEvent) => {
                        setCreateDconeAccount(e.checked)
                    }}
                    checked={createDconeAccount}
                    label={translate('accounts.createDconeAccount') as string}
                    onClick={() => setDconeAccountDirty(true)}
                  />
                  <p className={createAccountStyles.desc}><Translate id='accounts.recommend'/></p>
              </div>

              <div className={styles.formActions}>
                  <Button buttonType={ButtonType.SECONDARY} onClick={handleCancel}>
                      <Translate id='common.form.buttons.cancelBtn'/>
                  </Button>

                  <SubmitButton disabled={selectedServices.length === 0}>
                      <Translate id='common.form.buttons.updateServices'/>
                  </SubmitButton>
              </div>
          </Form>
      </div>
    )
}

export default connect(
  (state: IAppState): EditServicesStateProps => {
      return {
          profile: state.profile.data
      }
  },
  {
  }
)(EditServices)